<div class="bootstrap-validation-background--hidden" [formGroup]="form">
  <div class="container-fluid px-0">
    <div class="row">
      <div
        class="col-12"
        [ngClass]="{
          'col-md-6': inputMode === PasswordStrengthInputMode.ENTER_PASSWORD,
        }"
      >
        <!-- Password -->
        <div class="form-group">
          <label class="form-label" *portalTransclusion="transclusions; name: 'label'" for="password">
            {{ 'user.details.personalization.password' | translate }}
          </label>

          <div class="input-group">
            <input
              class="form-control"
              id="password"
              #passwordToText
              [inputGroupAppendButtonsTmpl]="inputGroupAppendButtonsTmpl"
              [passwordRepeatInput]="repeatInput"
              [toggleButtonClass]="'btn btn-outline-secondary'"
              autocomplete="new-password"
              formControlName="password"
              name="password"
              portal-password-to-text
              portalInputValidityState
              tabindex="1"
            />
            <ng-template #inputGroupAppendButtonsTmpl>
              <button
                class="btn btn-outline-secondary"
                [disabled]="loading || disabled"
                [portalTippy]="'passwordStrength.generatePassword' | translate"
                (click)="reloadPassword(); passwordToText.reset(false)"
                appendTo="body"
                tabindex="3"
                type="button"
              >
                <i
                  class="far"
                  [ngClass]="{
                    'fa-sync': loading === false,
                    'fa-circle-notch': loading,
                    'fa-spin': loading,
                  }"
                ></i>
              </button>

              @if (inputMode === PasswordStrengthInputMode.AUTOGENERATE) {
                <button
                  class="btn btn-outline-secondary"
                  [disabled]="disabled"
                  [portalTippy]="'passwordStrength.editPassword' | translate"
                  (click)="toggleMode(); passwordToText.reset()"
                  appendTo="body"
                  tabindex="4"
                  type="button"
                >
                  <i class="far fa-pencil"></i>
                </button>
              }
            </ng-template>
          </div>

          <div class="font-xs mt-1 text-info" *portalDelayedIf="form.get('password').pending">
            <i class="far fa-circle-notch fa-spin me-1"></i>
            <span>{{ 'passwordStrength.checkInProgress' | translate }}</span>
          </div>

          <portal-form-validation-errors controlName="password"></portal-form-validation-errors>
        </div>

        <!-- Password confirmation -->
        <div class="form-group" [hidden]="inputMode !== PasswordStrengthInputMode.ENTER_PASSWORD">
          <label class="form-label" for="passwordConfirmation">
            {{ 'user.details.personalization.passwordRetype' | translate }}
          </label>

          <input
            class="form-control"
            id="passwordConfirmation"
            #repeatInput
            [highlightIfFormGroupIsInvalid]="true"
            (input)="emitPassword()"
            autocomplete="new-password"
            formControlName="passwordConfirmation"
            name="passwordConfirmation"
            portalInputValidityState
            tabindex="2"
            type="password"
          />

          <portal-form-validation-errors
            [showIfFormGroupIsInvalid]="true"
            controlName="passwordConfirmation"
          ></portal-form-validation-errors>
        </div>
      </div>

      <!-- Strength criteria description -->
      @if (inputMode === PasswordStrengthInputMode.ENTER_PASSWORD) {
        <div class="col-md-6 col-12">
          <div>
            <label class="form-label">{{ 'passwordStrength.strengthCriteria' | translate }}</label>
            <ul class="list-unstyled">
              <li [ngClass]="{ 'text-primary': passwordStrength?.hasUppercaseLowercase }">
                {{ 'passwordStrength.hasUppercaseAndLowercase' | translate }}
                @if (passwordStrength?.hasUppercaseLowercase) {
                  <i class="far fa-check"></i>
                }
              </li>
              <li [ngClass]="{ 'text-primary': passwordStrength?.hasSpecialChar }">
                {{ 'passwordStrength.hasSpecialChar' | translate }}
                @if (passwordStrength?.hasSpecialChar) {
                  <i class="far fa-check"></i>
                }
              </li>
              <li [ngClass]="{ 'text-primary': passwordStrength?.hasNumbers }">
                {{ 'passwordStrength.hasNumbers' | translate }}
                @if (passwordStrength?.hasNumbers) {
                  <i class="far fa-check"></i>
                }
              </li>
              <li [ngClass]="{ 'text-primary': longEnough }">
                {{ 'passwordStrength.minimal' | translate }} {{ passwordStrength?.minimalLength }}
                {{ 'passwordStrength.char' | translate }}
                @if (form.value.password?.length >= passwordStrength?.minimalLength) {
                  <i class="far fa-check"></i>
                }
              </li>
              @if (form.value.password?.length > 0 && passwordStrength?.hasInvalidChars) {
                <li class="text-danger">
                  {{ 'passwordStrength.hasInvalidChars' | translate }}
                  <i class="far fa-times"></i>
                </li>
              }
            </ul>
          </div>
        </div>
      }
    </div>
  </div>
</div>
